<template>
  <div style="width: 100%;height: 100%;">
    <div class="curve-title">
      年用户增长
      <div class="curve-title-spot-top"></div>
      <div class="curve-title-spot-bottom"></div>
    </div>
    <div style="height: 3%"></div>
    <div className="proCharts" ref='round' style="width: 100%;height: 80%;"></div>
  </div>
</template>

<script>
import echarts from 'echarts' // npm install echarts@4.9.0
export default {
  name: 'roundDate',
  props: {
    'dataJSON': {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      option: {
        tooltip: {},
        xAxis: {
          data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
        },
        yAxis: {},
        series: [
          {
            name: '销量',
            type: 'pie',
            data: [5, 20, 36, 10, 10, 20]
          }
        ],
        legend: {
          orient: 'vertical',
          left: 'left'
        }
      }
    }
  },
  created () {

  },
  methods: {
    // 初始化图表
    mycharts () {
      // 初始化图表
      let myChart = echarts.init(this.$refs.round, 'lightTheme')
      myChart.setOption(
        {
          visualMap: {
            show: true,
            left: 30,
            bottom: 40,
            showLabel: true,
            textStyle: {color: '#ffffff'},
            pieces: [
              {label: '有用户', color: '#0092ff', name: '1月'}, // (900, 1000]
              {label: '用户较多', color: '#1cc900', name: '2月'}, // (500, 900]
              {label: '无用户', color: 'rgb(106,168,216)'} // [0]
            ]
          },
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: '55%', // 半径
              // 文本样式
              label: {
                // 文本普通样式
                normal: {
                  textStyle: {
                    color: 'rgba(255, 255, 255, 0.8)' // 文字颜色（红绿蓝,透明度）-白色
                  }
                }
              },
              // 引导线样式
              labelLine: {
                // 引导线普通样式
                normal: {
                  lineStyle: {
                    color: 'rgba(255, 255, 255, 0.4)' // 引导线颜色（红绿蓝,透明度）-白色
                  }
                }
              },
              // 具体数据
              data: [
                {name: '1月', value: 235},
                {name: '2月', value: 274},
                {name: '3月', value: 310},
                {name: '4月', value: 335},
                {name: '5月', value: 400},
                {name: '6月', value: 400},
                {name: '7月', value: 400},
                {name: '8月', value: 400},
                {name: '9月', value: 400},
                {name: '10月', value: 400},
                {name: '11月', value: 400},
                {name: '12月', value: 400}
              ]
            }
          ]
        }
      )
    }
  },
  mounted () {
    this.mycharts()
  }
}
</script>

<style scoped>
.curve-title {
  height: 17%;
  background-image: linear-gradient(to right, #0055bb,transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f0f0f0;
  font-size: 18px;
  position: relative;
}
.curve-title-spot-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #69aaff;
}
.curve-title-spot-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 5px;
  height: 5px;
  background-color: #69aaff;
}
/*.proCharts {*/
/*  width: 100%;*/
/*  height: 260px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/home/Round_date.vue